export default "__VITE_ASSET__oxWEF8p$__"